import { appendAPExamTemplate } from '@/functions/idp'

import RIC from './RIC_10'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
